<template>
    <section
        class="relative space-y-10 bg-gradient-to-t from-transparent via-accent/10 via-35% to-transparent md:space-y-15">
        <AtomTitle class="container text-center max-md:text-20/120">
            Приглашаем в&nbsp;офис в&nbsp;Санкт-Петербурге и&nbsp;Москве,<br />
            где покажем все оборудование и&nbsp;обсудим условия
        </AtomTitle>
        <h3
            class="container text-center text-16/148 font-medium text-white md:text-20/120 md:font-semibold">
            Наши офисы работают по&nbsp;будним дням с&nbsp;9:30 до&nbsp;18:30
        </h3>
        <div class="relative overflow-hidden max-md:container">
            <div
                class="relative z-30 flex items-stretch justify-center md:container md:gap-5">
                <picture class="h-auto">
                    <source
                        type="image/webp"
                        srcset="/assets/images/office/webp/spb-1.webp" />
                    <img
                        loading="lazy"
                        alt="офис Cromi"
                        src="/assets/images/office/jpg-png/spb-1.jpg"
                        class="hidden h-full w-[30rem] rounded-8 object-cover md:block lg:w-[41.75rem]" />
                </picture>
                <div
                    class="h-full w-full rounded-12 bg-white/5 p-3 backdrop-blur-2xl md:w-[26.75rem] md:p-5 lg:p-10">
                    <picture
                        class="h-auto w-full rounded-8 object-cover md:hidden">
                        <source
                            type="image/webp"
                            srcset="/assets/images/office/webp/spb-1.webp" />
                        <img
                            loading="lazy"
                            alt="офис Cromi"
                            src="/assets/images/office/jpg-png/spb-1.jpg"
                            class="h-auto w-full rounded-8 object-cover md:hidden" />
                    </picture>
                    <ul class="mt-10 space-y-10 max-md:text-center md:mt-0">
                        <li
                            v-for="(item, index) in contacts"
                            :key="index"
                            class="space-y-1 text-white">
                            <p
                                v-html="`${item.title}, ${item.address}`"
                                class="text-14/148 font-medium md:max-w-[240px] lg:text-16/148" />
                            <NuxtLink
                                :to="`tel:+${item.phone}`"
                                class="mt-1 inline-block text-16/120 font-semibold transition-colors duration-150 hover:text-accent-400 lg:text-24/133 lg:font-bold">
                                {{ item.phone }}
                            </NuxtLink>
                        </li>
                        <li class="text-white">
                            <p class="text-16/148 font-medium md:text-14/148">
                                Электронная почта
                            </p>
                            <div
                                class="mt-1 flex items-center text-16/120 max-md:justify-center lg:text-24/133">
                                <NuxtLink
                                    :to="`mailto:${email}`"
                                    class="font-semibold transition-colors duration-150 hover:text-accent-400 lg:font-bold">
                                    <span> {{ email }} </span>
                                </NuxtLink>
                                <BaseCopyButton
                                    size="small"
                                    :text-to-copy="email" />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="container absolute inset-0 size-full">
                <PerspectiveWallSVG
                    class="absolute -left-[12%] top-1/2 w-[25rem] -translate-y-1/2 max-md:hidden xl:left-0 xl:w-[29.25rem]" />
                <PerspectiveWallSVG
                    class="absolute right-[-10%] top-1/2 w-[25rem] -translate-y-1/2 -scale-x-100 max-md:hidden xl:right-0 xl:w-[29.25rem]" />
            </div>
        </div>
        <div
            v-if="showButton"
            class="mt-10 text-center md:mt-20">
            <BaseLink
                to="/contacts"
                size="accent">
                Как нас найти?
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import { contacts, email } from '~/const/company-info.consts'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseCopyButton from '~/components/base/base-copy-button/BaseCopyButton.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import PerspectiveWallSVG from '~/components/pages/directions/invite-section/svg/PerspectiveWallSVG.vue'

defineProps({
    showButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})
</script>
